export const useEquipmentFilterStyles = {
  filterButton: (isSelected, color) => ({
    fontSize: '14px',
    fontWeight: 600,
    textTransform: "initial",
    backgroundColor: isSelected ? color : "#fff",
    color: isSelected ? "#fff" : color,
    borderRadius: "20px",
    border: `1px solid ${color}`,
    height: '30px'
  }),
  selectAllButton: (disabled) => ({
    width: disabled ? '200px' : '120px'
  })
};